import { unitList } from "constants/unit";
import * as api from "../API/index";
import { authorizedUser } from "components/CommonComponent/CommonFunction";

//get all unit listing
export const getUnitListing = async (dispatch, pageNum, filters) => {
  try {
    const res = await api.get_unit_listing(pageNum, filters);
    dispatch({ type: unitList, payload: res?.data });
  } catch (error) {
    authorizedUser(error.response?.data);
    dispatch({
      type: unitList,
      payload: error?.response?.data ?? { message: error?.message },
    });
  }
};
